<template>
    <page-layout>
        <has-universe
            :universe="$route.params.universe"
        >
            <infinity-page
                :loading="loading"
                icon="mdi-shield-key-outline"
                color="teal"                
            >
                <universe-drawer />
                <template #title>
                    <h1
                        style="font-weight: 300; font-family: lato; font-weight: bold; letter-spacing: initial;"
                    >
                        Universe Secrets
                    </h1>
                    <h2 style="font-weight: 200">
                        Keep your application's secrets safe and sound
                    </h2>                            
                </template>
                <template #actions>
                    <v-btn 
                        color="deep-purple"
                        class="white--text px-6"
                        depressed
                        @click="save"
                    >
                        <v-icon left>
                            mdi-content-save
                        </v-icon> Save
                    </v-btn>
                </template>

                <v-sheet>
                    <v-container class="pa-12 pb-6">
                        <v-text-field 
                            v-model="query"
                            filled
                            shaped                            
                            placeholder="Search"
                        >
                            <template #prepend-inner>
                                <v-icon>mdi-magnify</v-icon>
                            </template>
                        </v-text-field>
                        <v-form>
                            <v-jsf 
                                v-model="model" 
                                :schema="schema" 
                                :options="options"
                                class="vjsf"
                            />                            
                        </v-form>                        
                    </v-container>
                    <v-container class="px-12 pb-12">
                        <infinity-separator 
                            icon="mdi-shield-key-outline"
                            text="Global secrets"
                        />
                        <v-form>
                            <v-jsf 
                                v-model="globalModel" 
                                :schema="globalSchema" 
                                :options="options"
                                class="vjsf"
                            />                            
                        </v-form> 
                    </v-container>
                </v-sheet>
                <template #sidebar>
                    <infinity-sidebar
                        icon="$vuetify.icons.help"
                        title="docs/multiverse"
                    >
                        <h4 class="text-h4 mb-3 text--primary">
                        Settings for the platform
                        </h4>

                        <p class="text--secondary">
                            Settings for the platform can be set on this page
                        </p>

                        <v-btn
                            class="mr-0 white--text"
                            color="deep-purple"                            
                            min-width="100"
                            rounded
                        >
                            I want to know more
                        </v-btn>
                    </infinity-sidebar>
                </template>
            </infinity-page>
        </has-universe>
    </page-layout>
</template>
<script>
    import VJsf from '@koumoul/vjsf/lib/VJsf.js'
    import axios from 'axios'
    import PageLayout from '@/layouts/default/PageLayout'    
    import UniverseDrawer from '@/layouts/Universe/Drawer'    
    import { mapState, mapActions, mapWritableState } from 'pinia'
    import { useSecretStore } from '@/store/secret-store'
    import schema from '@/assets/schemas/universe/secret.json'
    import globalSchema from '@/assets/schemas/universe/globalsecret.json'
    export default {
        components: {
            VJsf,
            PageLayout,
            UniverseDrawer,
        },
        data: () => {
            return {
                model: {},
                globalModel: {},
                schema: schema,
                globalSchema: globalSchema,
                options: {
                    httpLib: axios,
                    fieldProps: {
                        outlined: true,
                    },
                    arrayItemColProps: { cols: 6 },
                    arrayItemCardProps: {
                        outlined: true,
                        hover: true,
                        shaped: true,
                        style: 'margin: 10px',
                    },
                },
            }
        },
        computed: {
            ...mapState(useSecretStore, ['loading', 'secrets', 'globals']),
            ...mapWritableState(useSecretStore, ['query']),
        },
        watch: {
            secrets (v) {
                this.model = v                
            },
            globals (v) {
                this.globalModel = v                
            },
        },
        async mounted () {
            await this.loadSecrets(this.$route.params.universe)                        
        },        
        methods: {
            ...mapActions(useSecretStore, {
                loadSecrets: 'loadSecrets', 
                saveSecrets: 'saveSecrets',
            }),
            save () {
                this.saveSecrets(this.$route.params.universe, this.model)
            },
        },
    }
</script>
<style scoped>
.vjsf >>> .v-card__title {
    font-size: 24px ! important;
    font-weight: 600;
    font-family: 'lato' ! important;
}
</style>
